import {
    Dialog,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Box,
    Divider,
    DialogActions,
    Button,
    Paper,
    Grid,
    Chip,
    Stack
} from "@mui/material";
import {
    Business,
    LocalShipping,
    Schedule,
    Event
} from "@mui/icons-material";
import { formatarTelefone, formatarValorMonetario } from "../../../../../../../helpers/masks";
import moment from "moment";
import { CotacaoRealizada } from "..";


export default function DialogDetalharCotacao({ open, onClose, cotacao }: DialogDetalharCotacaoProps) {

    // Calcula o total dos itens
    const totalItens = cotacao.itens.reduce((total, item) => total + Number(item.valor_total), 0);

    // Calcula o total com frete
    const valorFrete = cotacao.valor_frete ? Number(cotacao.valor_frete) : 0;
    const totalComFrete = totalItens + valorFrete;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 1,
                        minHeight: '50vh'
                    }
                }
            }}
        >
            <DialogTitle>
                Detalhes da Cotação
            </DialogTitle>

            <DialogContent sx={{ p: 3 }}>
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 600,
                        color: '#333',
                        mb: 2
                    }}>
                        Informações Gerais
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <Box sx={{
                                p: 2,
                                bgcolor: '#f8f9fa',
                                borderRadius: 1,
                                border: '1px solid #e9ecef'
                            }}>
                                <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                                    <Business color="primary" fontSize="small" />
                                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                                        Fornecedor
                                    </Typography>
                                </Stack>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {cotacao.fornecedor_id} - {cotacao.fornecedor}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <Box sx={{
                                p: 2,
                                bgcolor: '#f8f9fa',
                                borderRadius: 1,
                                border: '1px solid #e9ecef'
                            }}>
                                <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                                    <Schedule color="primary" fontSize="small" />
                                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                                        Prazo de Entrega
                                    </Typography>
                                </Stack>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {cotacao.prazo_entrega ? `${cotacao.prazo_entrega} dias` : 'N/A'}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <Box sx={{
                                p: 2,
                                bgcolor: '#f8f9fa',
                                borderRadius: 1,
                                border: '1px solid #e9ecef'
                            }}>
                                <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                                    <LocalShipping color="primary" fontSize="small" />
                                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                                        Valor do Frete
                                    </Typography>
                                </Stack>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {cotacao.valor_frete ? formatarValorMonetario(Number(cotacao.valor_frete)) : 'N/A'}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <Box sx={{
                                p: 2,
                                bgcolor: '#f8f9fa',
                                borderRadius: 1,
                                border: '1px solid #e9ecef'
                            }}>
                                <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                                    <Event color="primary" fontSize="small" />
                                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                                        Vencimento
                                    </Typography>
                                </Stack>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {moment(cotacao.vencimento).format('DD/MM/YYYY')}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Divider sx={{ my: 3 }} />
                <Box>
                    <Typography variant="h6" sx={{
                        fontWeight: 600,
                        color: '#333',
                        mb: 2
                    }}>
                        Informações do Vendedor
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box sx={{
                                p: 2,
                                bgcolor: '#f8f9fa',
                                borderRadius: 1,
                                border: '1px solid #e9ecef'
                            }}>
                                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500, mb: 1 }}>
                                    Nome do Vendedor
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {cotacao.nome_vendedor || 'N/A'}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box sx={{
                                p: 2,
                                bgcolor: '#f8f9fa',
                                borderRadius: 1,
                                border: '1px solid #e9ecef'
                            }}>
                                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500, mb: 1 }}>
                                    Telefone do Vendedor
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {cotacao.telefone_vendedor ? formatarTelefone(cotacao.telefone_vendedor) : 'N/A'}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <Box sx={{
                                p: 2,
                                bgcolor: '#f8f9fa',
                                borderRadius: 1,
                                border: '1px solid #e9ecef'
                            }}>
                                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500, mb: 1 }}>
                                    Email do Vendedor
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {cotacao.email_vendedor || 'N/A'}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h6" sx={{
                        fontWeight: 600,
                        color: '#333',
                        mb: 2
                    }}>
                        Itens da Cotação
                    </Typography>

                    <TableContainer component={Paper} sx={{
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        border: '1px solid #e0e0e0',
                        borderRadius: 1
                    }}>
                        <Table size="medium">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                                    <TableCell sx={{ fontWeight: 600, color: '#333' }}>
                                        Produto
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: '#333' }}>
                                        Quantidade
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: '#333' }}>
                                        Valor Unitário
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: '#333' }}>
                                        Valor Total
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: '#333' }}>
                                        Impostos
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {cotacao?.itens.map((item, index) => (
                                    <TableRow
                                        key={item.id}
                                        sx={{
                                            '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                    >
                                        <TableCell>
                                            <Box>
                                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                    {item.produto_nome}
                                                </Typography>
                                                <Chip
                                                    label={item.unidade_medida}
                                                    size="small"
                                                    variant="outlined"
                                                    sx={{
                                                        mt: 0.5,
                                                        fontSize: '0.7rem',
                                                        height: '20px',
                                                        borderColor: '#ccc',
                                                        color: '#666'
                                                    }}
                                                />
                                            </Box>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="body2">
                                                {item.quantidade}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="body2" sx={{ color: '#1976d2' }}>
                                                {formatarValorMonetario(item.valor_unitario)}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography variant="body2" sx={{
                                                fontWeight: 600,
                                                color: '#2e7d32'
                                            }}>
                                                {formatarValorMonetario(Number(item.valor_total))}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                {item.impostos && item.impostos.length > 0 ? (
                                                    item.impostos.map((imposto, impostoIndex) => (
                                                        <Chip
                                                            key={impostoIndex}
                                                            label={`${imposto.tipo}: ${imposto.valor}% - ${imposto.incluso_preco ? 'Incluso no preço' : 'Não incluso no preço'} / ${imposto.direito_credito ? 'Direito a crédito' : 'Sem direito a crédito'}`}
                                                            size="small"
                                                            variant="outlined"
                                                            sx={{
                                                                backgroundColor: '#fff3e0',
                                                                borderColor: '#ffb74d',
                                                                color: '#f57c00',
                                                                fontSize: '0.7rem',
                                                                height: '20px'
                                                            }}
                                                        />
                                                    ))
                                                ) : (
                                                    <Chip
                                                        label="Sem impostos"
                                                        size="small"
                                                        variant="outlined"
                                                        sx={{
                                                            backgroundColor: '#e8f5e8',
                                                            borderColor: '#81c784',
                                                            color: '#388e3c',
                                                            fontSize: '0.7rem',
                                                            height: '20px'
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Resumo dos Valores */}
                    <Box sx={{
                        mt: 3,
                        p: 2,
                        bgcolor: '#f8f9fa',
                        borderRadius: 1,
                        border: '1px solid #e9ecef'
                    }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography variant="body2" color="text.secondary">
                                    Subtotal dos Itens
                                </Typography>
                                <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
                                    {formatarValorMonetario(totalItens)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography variant="body2" color="text.secondary">
                                    Valor do Frete
                                </Typography>
                                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1976d2' }}>
                                    {formatarValorMonetario(valorFrete)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography variant="body2" color="text.secondary">
                                    Total
                                </Typography>
                                <Typography variant="h6" sx={{
                                    fontWeight: 700,
                                    color: '#2e7d32',
                                    fontSize: '1.25rem'
                                }}>
                                    {formatarValorMonetario(totalComFrete)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box sx={{
                        mt: 3,
                        p: 2,
                        bgcolor: '#f8f9fa',
                        borderRadius: 1,
                        border: '1px solid #e9ecef'
                    }}>
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Observações do Fornecedor
                        </Typography>
                        <Typography variant="body2" >
                            {cotacao.observacoes_fornecedor || 'Nenhuma observação fornecida.'}
                        </Typography>
                    </Box>
                </Box>


            </DialogContent>

            <DialogActions sx={{ p: 3, pt: 1 }}>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    sx={{
                        px: 3,
                        py: 1,
                        borderRadius: 1,
                        textTransform: 'none',
                        fontWeight: 500
                    }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogDetalharCotacaoProps {
    open: boolean;
    onClose: () => void;
    cotacao: CotacaoRealizada;
}